import React, { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom';
import * as moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineSearch, AiOutlineEdit } from "react-icons/ai";
import axioPath from '../../../../../api/axioPath';
import Spinner from '../../../../components/Spinner'
import { adminUserList } from '../../../../../redux/actions/admin';
import { SearchWrapper, Header, TableSection } from '../DashBoard/dashBoardStyled'
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'

import { Table } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';
import { storeAdminDetails, logoutAdmin } from 'redux/actions/admin';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';

import AddNonUserModal from './AddNonUserModal'


const buttonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }

function Users() {
    const dispatch = useDispatch();
    let history = useHistory()
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [modal, setModal] = useState(false);
    const adminRoles = useSelector(state => state.admin.adminRoles)
    const [addAdminModal, setAddAdminModal] = useState(false)
    const [dataList, setDataList] = useState([])
    const [adminDataList, setAdminDataList] = useState([])
    const [adminFinalData, setAdminFinalData] = useState([])
    const [tableSearch, setTableSearch] = useState('')
    const [page, setPage] = useState(1);
    const [adminPage, setAdminPage] = useState(1);
    const [adminPageCount, setAdminPageCount] = useState(0);
    const loggedInAuthId = localStorage.getItem('adminAuthId')
    const [modalMessage, setModalMessaage] = useState('')



    useEffect(() => {
        let userRole = localStorage.getItem('accountType')
        let appUserRolesList = ['Both', 'Buyer', 'Seller']
        if (userRole !== 'Admin') {
            if (appUserRolesList.includes(userRole)) history.push('/dashboard')
            else history.push('/sign-in')
            window.location.reload();
        }
    }, []);



    const fetchMyAdminAPI = async () => {
        let response = '';
        response = await dispatch(adminUserList());
        if (response.status === 200) {
            if (response.data.length && response.data.length !== 0) {
                let adminUserDataListTemp = response.data
                let adminUserDataList = adminUserDataListTemp.filter(val => val.userId !== loggedInAuthId)
                let pageData = JSON.parse(JSON.stringify(adminUserDataList.reverse()))
                setAdminDataList(adminUserDataList)
                setAdminFinalData(pageData.splice(page * 10 - 10, 10))
                if (adminUserDataList.length % 10 === 0) {
                    setAdminPageCount(adminUserDataList.length / 10)
                } else {
                    setAdminPageCount(Math.trunc(adminUserDataList.length / 10) + 1)
                }
                setTableSearch('')
            } else if (response.data && response.data.message === 'Unauthorized (Invalid token)') adminLogout()
        }
    };

    const adminLogout = () => {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
    }

    //handle page change in admins
    const handleAdminChange = (event, value) => {
        setAdminPage(value);
        const search = tableSearch
        let dataListtemp = adminDataList.filter(value => {
            return (
                (value.userId !== null && value.userId.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.name !== null && value.name.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.email !== null && value.email.toString().toLowerCase().includes(search.toLowerCase())))
        }
        );
        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setAdminFinalData(pageData.splice(value * 10 - 10, 10))
    };

    const handleSearchChange = e => {
        e.preventDefault()
        setTableSearch(e.target.value)
        const search = e.target.value

        //admins
        let dataAdminListtemp = adminDataList.filter(value => {
            return (
                (value.userId !== null && value.userId.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.name !== null && value.name.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.email !== null && value.email.toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        setAdminPage(1)
        if (dataAdminListtemp.length % 10 === 0) {
            setAdminPageCount(dataAdminListtemp.length / 10)
        } else {
            setAdminPageCount(Math.trunc(dataAdminListtemp.length / 10) + 1)
        }
        setAdminFinalData(dataAdminListtemp.splice(0, 10))
    }



    let adminHeaderArr = [
        { title: 'User Name', },
        { title: 'Email ID', },
        { title: 'Cell Phone Number', },
        { title: 'Referral Code', },
        { title: 'Actions', }
    ];

    const closeAdminModal = values => {
        const token = localStorage.getItem("token")
        const roles = values.access.map(data => data.value)
        let url = `/access/${values.email}/${roles}`
        axioPath.get(url, {
            headers: {
                Authorization: token,
                token: token
            },
        }).then((response) => {
            setAddAdminModal(false)
            setModalMessaage(response.data.message)
            setModal(!modal)
        }).catch((ex) => {
            setAddAdminModal(false)
        });
    }

    return (
        <>
            {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('APPLICATION_NON_USERS'))) ?
                <Container>
                    <TableWrapper>
                        {loaderVisible && <Spinner />}
                        <Heading>
                            <h3>APPLICATION NON USER</h3>

                            <div style={{ display: 'flex', width: '535px' }}>
                                <button
                                    style={buttonStyle}
                                    onClick={e => setAddAdminModal(true)}
                                >
                                    Add Non User
                                </button>
                                <SearchWrapper>
                                    <input type="text" placeholder='Search' value={tableSearch}
                                        onChange={handleSearchChange} />
                                    <AiOutlineSearch />
                                </SearchWrapper>
                            </div>
                        </Heading>



                        <Table responsive>
                            <thead>
                                <tr>
                                    {adminHeaderArr.map((items, index) => (
                                        <th key={index}>{items.title}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    adminFinalData.map((items, index) => (
                                        <tr key={index}>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <AiOutlineEdit
                                                    title="Edit Admin Roles"
                                                    onClick={(e) => {
                                                    }}
                                                    style={{ margin: '0px 10px 0px 10px', height: '23px', width: '23px', cursor: 'pointer' }} />
                                            </td>

                                        </tr>
                                    ))}
                            </tbody>
                        </Table>

                        {adminDataList.length !== 0 && <Pagination count={adminPageCount}
                            page={adminPage}
                            onChange={handleAdminChange} />}



                        <Modal isOpen={addAdminModal} centered={true}>
                            <ModalHeader toggle={() => setAddAdminModal(false)}><h6>Add Non User</h6></ModalHeader>
                            <ModalBody>
                                <AddNonUserModal onEnter={closeAdminModal} />
                            </ModalBody>
                        </Modal>

                    </TableWrapper>
                </Container >

                :
                <p>You are not authorized to view this page.</p>
            }
        </>

    )
};

export default Users;

const Container = styled.div`
  
  /* .MuiTabs-flexContainer {
                    border-bottom: 4px solid #e8e8e8;
} */
`;